import React, {
    Component,
    Fragment,
} from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { SearchResult } from 'wanderu-component-search-result';
import { localize } from 'wanderu-i18n';

import Events from './events/SearchListEvents';

import styles from './SearchList.scss';

class SearchList extends Component {
    static propTypes = {
        activeSortType: PropTypes.string.isRequired,
        batchId: PropTypes.string,
        direction: PropTypes.string.isRequired,
        disabled: PropTypes.bool,
        i18nMoney: PropTypes.func.isRequired,
        inlineSearchAds: PropTypes.arrayOf(PropTypes.object),
        noResults: PropTypes.bool,
        onSelect: PropTypes.func.isRequired,
        paxCount: PropTypes.number,
        searchParams: PropTypes.object.isRequired,
        showNum: PropTypes.number.isRequired,
        tripMetadata: PropTypes.object.isRequired,
        trips: PropTypes.arrayOf(PropTypes.object).isRequired,
    };

    static defaultProps = {
        batchId: '',
        inlineSearchAds: [],
        noResults: false,
        paxCount: 1,
    };

    handleSelect = (tripId) => {
        const {
            activeSortType,
            batchId,
            direction,
            onSelect,
            paxCount,
            trips,
        } = this.props;
        const tripPosition = trips.findIndex(
            (trip) => trip.tripId === tripId,
        );
        const trip = trips[tripPosition];
        // TODO: pricing in carrier preferred currency
        const price = Object.values(trip.pricing[0])[0];
        Events.tripSelected({
            activeSortType,
            batchId,
            direction,
            paxCount,
            position: tripPosition,
            price,
            resultsCount: trips?.length,
            resultsVisible: this.props.showNum,
            trip,
            tripId,
        });
        onSelect(tripId, trip);
    };

    render() {
        const {
            disabled,
            inlineSearchAds,
            noResults,
            showNum,
            tripMetadata,
            trips,
        } = this.props;

        const tripsToShow = trips.slice(0, showNum);
        const totalTrips = trips.length;

        if (inlineSearchAds.length > 0) {
            inlineSearchAds.forEach(({ idx, ad }) => tripsToShow.splice(idx, 0, ad));
        }

        return <>
            {tripsToShow.map((trip, index) => trip?.tripId
                ? (
                    <SearchResult
                        key={trip?.tripId}
                        {...trip}
                        arriveIsNearby={
                            !tripMetadata[trip.tripId]
                                ?.exactDestMatch
                        }
                        departIsNearby={
                            !tripMetadata[trip.tripId]
                                ?.exactOriginMatch
                        }
                        disabled={disabled}
                        onSelect={this.handleSelect}
                        position={index}
                        totalTrips={totalTrips}
                    />
                )
                : (
                    <div className={classNames({ [styles.hideOnMobile]: noResults })} key={`ad-${index}`}>
                        {trip}
                    </div>
                ))}
        </>;
    }
}

export { SearchList };
export default localize(SearchList, 'baseApp');
